import { Breadcrumb, Col, Row } from "antd";
import { Link } from "react-router-dom";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import FormHardPromotion from "./components/hard-promotion.form";
import { HardPromotionMutateFormProvider } from "./contexts/hard-promotion-form.context";
import React from "react";
import PanelItems from "./components/items.panel";
import PanelFree from "./components/free.panel";
import ModalClone from "./components/clone.modal";

const HardPromotionDetail = () => {
  return (
    <HardPromotionMutateFormProvider>
      <Breadcrumb className="mb-2">
        <Breadcrumb.Item>
          <Link to="/">หน้าหลัก</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/marketing/hard-promotion">รายการโปรโมชัน</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>รายละเอียดโปรโมชัน</Breadcrumb.Item>
      </Breadcrumb>
      <Panel>
        <PanelHeader>รายละเอียดโปรโมชัน</PanelHeader>
        <PanelBody>
          <FormHardPromotion />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <PanelItems />
            </Col>
            <Col xs={24} md={12}>
              <PanelFree />
            </Col>
          </Row>
        </PanelBody>
      </Panel>
      <ModalClone />
    </HardPromotionMutateFormProvider>
  );
};

export default HardPromotionDetail;
